var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSpinner),expression:"showSpinner"}],staticClass:"spinner-box"},[_c('div',{staticClass:"circle-border"},[_c('div',{staticClass:"circle-core"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }